import { render, staticRenderFns } from "./DayAgendaListPlaceholder.vue?vue&type=template&id=1b09715e&scoped=true"
import script from "./DayAgendaListPlaceholder.vue?vue&type=script&lang=js"
export * from "./DayAgendaListPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./DayAgendaListPlaceholder.vue?vue&type=style&index=0&id=1b09715e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b09715e",
  null
  
)

export default component.exports